import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/stores/auth";
import { api } from "@/lib/api";

/**
 * Gates the authenticated app. On mount we ping `/auth/me` once to validate
 * the stored session — if the panel rejects it (revoked / expired refresh),
 * we wipe local state and bounce to `/login`.
 */
export function AuthGate({ children }: { children: React.ReactNode }) {
  const { session, setSession } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    (async () => {
      try {
        await api("/auth/me");
      } catch {
        if (!cancelled) setSession(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [session, setSession]);

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
